import { render } from "./CreateFileInsidePanoramaFeatureSection.vue?vue&type=template&id=91f6b4ae"
import script from "./CreateFileInsidePanoramaFeatureSection.vue?vue&type=script&lang=js"
export * from "./CreateFileInsidePanoramaFeatureSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "91f6b4ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91f6b4ae', script)) {
    api.reload('91f6b4ae', script)
  }
  
  module.hot.accept("./CreateFileInsidePanoramaFeatureSection.vue?vue&type=template&id=91f6b4ae", () => {
    api.rerender('91f6b4ae', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/Panorama/CreateFileInsidePanoramaFeatureSection.vue"

export default script